(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"] && !Shopify.designMode) return;
  try {
    
  jQuery(function($) {
    $('[data-article-gallery]').each(function() {
      var $gallery = $(this);
      var $track = $gallery.find('.article-gallery__track');
      var $dots = $gallery.find('.article-gallery__dots');
      var $prev = $gallery.find('.article-gallery__arrow--prev');
      var $next = $gallery.find('.article-gallery__arrow--next');

      $track.on('init afterChange', function(e, slick) {
        var atStart = slick.currentSlide === 0;
        var atEnd = slick.currentSlide >= slick.slideCount - 1;
        $prev.prop('disabled', atStart);
        $next.prop('disabled', atEnd);
      });

      $track.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: true,
        appendDots: $dots,
        customPaging: function(slider, i) {
          return '<button type="button" aria-label="Image ' + (i + 1) + '"></button>';
        }
      });

      $prev.on('click', function() { $track.slick('slickPrev'); });
      $next.on('click', function() { $track.slick('slickNext'); });
    });

    $('[data-copy-url]').on('click', function() {
      var url = $(this).data('copy-url');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-post-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.blog-post-banner__copy-link').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = btn.dataset.shareUrl;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {

    /* ────────────────── Drawer open / close ────────────────── */
    var drawer = document.getElementById('collection-filter-drawer');
    var toggleBtn = document.querySelector('.collection-section__filter-toggle');

    function openDrawer() {
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('collection-filter--open');
      });
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('collection-filter--open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 300);
    }

    if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);

    drawer.querySelectorAll('[data-close-drawer]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* ────────────────── Filter state ───────────────────────── */
    var state = {
      lifestyle: new Set(),
      condition: 'all',
      brands: new Set(),
      keyword: '',
      length: Infinity,
      price: Infinity,
      productType: new Set(),
      trailer: false
    };

    /* Parse a metafield value that could be a plain string, comma-separated
       string, or a JSON array string like ["Surtees","Stabicraft"] */
    function parseMeta(raw) {
      if (!raw) return [];
      var trimmed = raw.trim();
      if (trimmed.charAt(0) === '[') {
        try {
          var arr = JSON.parse(trimmed);
          return Array.isArray(arr) ? arr.map(function (v) { return String(v).trim(); }) : [String(arr).trim()];
        } catch (e) { /* fall through */ }
      }
      return trimmed.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }

    /* ────────────────── Populate dynamic filter options ───── */
    function populateFilters() {
      var cards = document.querySelectorAll('[data-product-card]');
      var lifestyles = new Map();
      var productTypes = new Set();
      var maxLength = 0;

      cards.forEach(function (card) {
        if (card.dataset.lifestyle && card.dataset.lifestyleKey) {
          lifestyles.set(card.dataset.lifestyleKey, card.dataset.lifestyle);
        }
        parseMeta(card.dataset.productType).forEach(function (t) { if (t) productTypes.add(t); });
        var len = parseFloat(card.dataset.length || 0);
        if (len > maxLength) maxLength = len;
      });

      /* Lifestyle checkboxes */
      var lifestyleTarget = drawer.querySelector('[data-options-target="lifestyle"]');
      if (lifestyleTarget) {
        lifestyles.forEach(function (label, key) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cf-checkbox-btn';
          btn.setAttribute('aria-pressed', 'false');
          btn.dataset.filter = 'lifestyle';
          btn.dataset.value = key;
          btn.innerHTML = '<span class="cf-checkbox-box"></span><span class="cf-option-text">' + label + '</span>';
          btn.addEventListener('click', function () { toggleCheckbox(this, 'lifestyle'); });
          lifestyleTarget.appendChild(btn);
        });
      }

      /* Product type pills — "View All" first */
      var ptTarget = drawer.querySelector('[data-options-target="product-type"]');
      if (ptTarget) {
        ptTarget.appendChild(makePill('View All', 'product-type'));
        productTypes.forEach(function (type) {
          ptTarget.appendChild(makePill(type, 'product-type'));
        });
      }

      /* Adjust slider maxes if data found */
      var lengthInput = drawer.querySelector('[data-filter="length"]');
      if (lengthInput && maxLength > 0 && maxLength > 50) {
        lengthInput.max = Math.ceil(maxLength);
        lengthInput.value = Math.ceil(maxLength);
      }
      /* Price slider max is set in Liquid and refined by setPriceMax() */
      updateAllSliders();
    }

    function makePill(label, group) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cf-pill';
      btn.textContent = label;
      btn.setAttribute('aria-pressed', 'false');
      btn.dataset.filter = group;
      btn.dataset.value = label === 'View All' ? '' : label.toLowerCase();
      btn.addEventListener('click', function () { togglePill(this, group); });
      return btn;
    }

    /* ────────────────── Full collection scan (brands + cross-page filtering) ───── */
    var gridContainer = document.querySelector('[data-product-grid]');
    var paginationNav = document.querySelector('[data-pagination-nav]');
    var originalGridHTML = gridContainer ? gridContainer.innerHTML : '';
    var allProductCards = null; /* becomes an array of card elements once the full scan finishes */

    function renderBrandPills(brandSet) {
      var brandsTarget = drawer.querySelector('[data-options-target="brands"]');
      if (!brandsTarget) return;
      brandsTarget.innerHTML = '';
      Array.from(brandSet).sort(function (a, b) { return a.localeCompare(b); }).forEach(function (brand) {
        brandsTarget.appendChild(makePill(brand, 'brands'));
      });
    }

    /* Builds the AJAX URL for one page of the full-collection scan, preserving
       the current sort/tag context but always controlling `page` ourselves so
       it isn't tied to whatever page of the 12-per-page grid is on screen. */
    function buildScanUrl(sectionId, page) {
      var params = new URLSearchParams(window.location.search);
      params.delete('page');
      params.set('section_id', sectionId);
      if (page > 1) params.set('page', page);
      return window.location.pathname + '?' + params.toString();
    }

    function fetchScanPage(sectionId, page) {
      return fetch(buildScanUrl(sectionId, page), { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var scanRoot = doc.querySelector('[data-all-products] [data-total-pages]');
          var cards = scanRoot ? Array.from(scanRoot.querySelectorAll('[data-product-card]')) : [];
          var totalPages = scanRoot ? (parseInt(scanRoot.dataset.totalPages, 10) || 1) : 1;
          return { cards: cards, totalPages: totalPages };
        });
    }

    /* Sets the price slider max to the highest card price (cents → dollars),
       rounded up to the next $100. Keeps the user's value if they've moved it. */
    function setPriceMax(cards) {
      var priceInput = drawer.querySelector('[data-filter="price"]');
      if (!priceInput) return;
      var maxCents = 0;
      cards.forEach(function (card) {
        var p = parseInt(card.dataset.price || 0, 10);
        if (p > maxCents) maxCents = p;
      });
      if (maxCents <= 0) return;
      var ceiling = Math.ceil(maxCents / 100 / 100) * 100;
      var wasAtMax = !isFinite(state.price);
      priceInput.max = ceiling;
      if (wasAtMax) priceInput.value = ceiling;
      updateSlider(priceInput);
    }

    function loadAllProducts() {
      var scanContainer = document.querySelector('[data-all-products]');
      var sectionId = scanContainer ? scanContainer.dataset.sectionId : null;
      if (!sectionId) return;

      fetchScanPage(sectionId, 1).then(function (first) {
        var cards = first.cards;
        var pending = [];
        for (var p = 2; p <= first.totalPages; p++) {
          pending.push(fetchScanPage(sectionId, p));
        }
        return Promise.all(pending).then(function (rest) {
          rest.forEach(function (page) { cards = cards.concat(page.cards); });
          return cards;
        });
      }).catch(function () {
        /* Network failure — fall back to only the cards on the current page */
        return Array.from(document.querySelectorAll('[data-product-card]'));
      }).then(function (cards) {
        allProductCards = cards;
        var brands = new Set();
        cards.forEach(function (card) {
          parseMeta(card.dataset.brands).forEach(function (b) { if (b) brands.add(b); });
        });
        renderBrandPills(brands);
        setPriceMax(cards);
        initFiltersFromURL();
        applyFilters();
      });
    }

    /* Re-binds the hover/click image-carousel behaviour for cards within `root`
       (used both on initial load and whenever the grid is re-rendered). */
    function initCardCarousels(root) {
      root.querySelectorAll('.collection-section__card').forEach(function (card) {
        var images = card.querySelectorAll('.collection-section__card-img');
        var indicators = card.querySelectorAll('.collection-section__indicator');
        if (!indicators.length || !images.length) return;

        function showImage(idx) {
          images.forEach(function (img) { img.classList.remove('collection-section__card-img--visible'); });
          indicators.forEach(function (ind) { ind.classList.remove('collection-section__indicator--active'); ind.setAttribute('aria-selected', 'false'); });
          if (images[idx]) images[idx].classList.add('collection-section__card-img--visible');
          if (indicators[idx]) { indicators[idx].classList.add('collection-section__indicator--active'); indicators[idx].setAttribute('aria-selected', 'true'); }
        }

        indicators.forEach(function (ind) {
          ind.addEventListener('mouseenter', function () { showImage(parseInt(this.dataset.index, 10)); });
          ind.addEventListener('click', function () { showImage(parseInt(this.dataset.index, 10)); });
        });
        card.addEventListener('mouseleave', function () { showImage(0); });
      });
    }

    function renderGridCards(nodes) {
      if (!gridContainer) return;
      gridContainer.innerHTML = '';
      if (nodes.length === 0) {
        var empty = document.createElement('p');
        empty.className = 'col-span-full text-center text-[#0b0303] py-16';
        empty.style.fontSize = '18px';
        empty.textContent = gridContainer.dataset.noFilteredProductsText || 'No products match the selected filters.';
        gridContainer.appendChild(empty);
      } else {
        nodes.forEach(function (n) { gridContainer.appendChild(n); });
      }
      initCardCarousels(gridContainer);
    }

    function restoreOriginalGrid() {
      if (!gridContainer || gridContainer.innerHTML === originalGridHTML) return;
      gridContainer.innerHTML = originalGridHTML;
      initCardCarousels(gridContainer);
    }

    /* True while any filter is set, so applyFilters() knows whether to show
       the whole collection's matches (client-rendered) or the plain,
       server-paginated 12-per-page grid. */
    function isAnyFilterActive() {
      return state.lifestyle.size > 0 ||
        (state.condition && state.condition !== 'all') ||
        state.brands.size > 0 ||
        !!state.keyword ||
        isFinite(state.length) ||
        isFinite(state.price) ||
        state.productType.size > 0 ||
        state.trailer;
    }

    function cardMatchesState(card) {
      if (state.lifestyle.size > 0 && !state.lifestyle.has(card.dataset.lifestyleKey || '')) return false;

      if (state.condition && state.condition !== 'all') {
        if ((card.dataset.condition || '').toLowerCase() !== state.condition) return false;
      }

      if (state.brands.size > 0) {
        var cardBrands = parseMeta(card.dataset.brands).map(function (b) { return b.toLowerCase(); });
        var brandMatched = false;
        state.brands.forEach(function (b) { if (cardBrands.indexOf(b.toLowerCase()) !== -1) brandMatched = true; });
        if (!brandMatched) return false;
      }

      if (state.keyword) {
        var title = normalizeText(card.dataset.title);
        var allWords = state.keyword.split(' ').every(function (word) { return title.indexOf(word) !== -1; });
        if (!allWords) return false;
      }

      if (isFinite(state.length)) {
        var len = parseFloat(card.dataset.length || 0);
        if (len > state.length) return false;
      }

      if (isFinite(state.price)) {
        /* data-price is in cents; the slider works in dollars */
        var price = parseInt(card.dataset.price || 0, 10) / 100;
        if (price > state.price) return false;
      }

      if (state.productType.size > 0) {
        var cardTypes = parseMeta(card.dataset.productType).map(function (t) { return t.toLowerCase(); });
        var typeMatched = false;
        state.productType.forEach(function (t) { if (cardTypes.indexOf(t) !== -1) typeMatched = true; });
        if (!typeMatched) return false;
      }

      if (state.trailer) {
        var tv = (card.dataset.trailer || '').toLowerCase();
        if (tv !== 'true' && tv !== 'yes' && tv !== '1') return false;
      }

      return true;
    }

    /* ────────────────── Checkbox toggle ─────────────────────── */
    function toggleCheckbox(btn, group) {
      var pressed = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      var val = btn.dataset.value;
      if (pressed) { state[group].delete(val); } else { state[group].add(val); }
      applyFilters();
    }

    /* ────────────────── Radio (condition) ───────────────────── */
    drawer.querySelectorAll('.cf-radio-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.querySelectorAll('.cf-radio-btn').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          var ind = b.querySelector('.cf-radio-indicator');
          if (ind) { ind.classList.remove('cf-radio-indicator--checked'); ind.innerHTML = ''; }
        });
        this.setAttribute('aria-pressed', 'true');
        var ind = this.querySelector('.cf-radio-indicator');
        if (ind) {
          ind.classList.add('cf-radio-indicator--checked');
          ind.innerHTML = '<span class="cf-radio-dot"></span>';
        }
        state.condition = this.dataset.value;
        applyFilters();
      });
    });

    /* ────────────────── Pill toggle ─────────────────────────── */
    function activatePill(pill, group) {
      pill.setAttribute('aria-pressed', 'true');
      pill.classList.add('cf-pill--active');
    }

    function deactivatePill(pill) {
      pill.setAttribute('aria-pressed', 'false');
      pill.classList.remove('cf-pill--active');
    }

    function togglePill(pill, group) {
      var val = pill.dataset.value;

      if (group === 'product-type') {
        if (val === '') {
          /* "View All" — deselect others */
          drawer.querySelectorAll('[data-filter="product-type"]').forEach(deactivatePill);
          activatePill(pill, group);
          state.productType.clear();
        } else {
          /* Deselect "View All" */
          var viewAll = drawer.querySelector('[data-filter="product-type"][data-value=""]');
          if (viewAll) deactivatePill(viewAll);
          var active = pill.getAttribute('aria-pressed') === 'true';
          if (active) { deactivatePill(pill); state.productType.delete(val); }
          else { activatePill(pill, group); state.productType.add(val); }
          /* If nothing selected, re-activate View All */
          if (state.productType.size === 0) {
            if (viewAll) activatePill(viewAll, group);
          }
        }
      } else {
        var active = pill.getAttribute('aria-pressed') === 'true';
        if (active) { deactivatePill(pill); state[group === 'brands' ? 'brands' : group].delete(val); }
        else { activatePill(pill, group); state[group === 'brands' ? 'brands' : group].add(val); }
      }
      applyFilters();
    }

    /* ────────────────── Keyword ─────────────────────────────── */
    var keywordInput = drawer.querySelector('[data-filter="keyword"]');
    if (keywordInput) {
      keywordInput.addEventListener('input', function () {
        state.keyword = normalizeText(this.value);
        applyFilters();
      });
    }

    /* Lowercase, strip accents/punctuation and collapse spaces so "Stabi-craft  1850" ≈ "stabi craft 1850" */
    function normalizeText(str) {
      return String(str || '')
        .toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    /* ────────────────── Range sliders ───────────────────────── */
    function updateAllSliders() {
      drawer.querySelectorAll('.cf-slider-input').forEach(function (input) {
        updateSlider(input);
      });
    }

    function formatPrice(v) {
      return '$' + v.toLocaleString('en-AU');
    }

    function updateSlider(input) {
      var key = input.dataset.filter;
      var pct = ((input.value - input.min) / (input.max - input.min)) * 100;
      var fill = drawer.querySelector('[data-slider-fill="' + key + '"]');
      var valEl = drawer.querySelector('[data-slider-val="' + key + '"]');
      if (fill) fill.style.width = pct + '%';
      if (valEl) {
        if (key === 'length') {
          valEl.textContent = (parseInt(input.value, 10) >= parseInt(input.max, 10)) ? '50+' : input.value + 'ft';
        } else if (key === 'price') {
          valEl.textContent = formatPrice(parseInt(input.value, 10));
        }
      }
      if (key === 'length') {
        var lv = parseInt(input.value, 10);
        state.length = lv >= parseInt(input.max, 10) ? Infinity : lv;
      }
      if (key === 'price') {
        var pv = parseInt(input.value, 10);
        state.price = pv >= parseInt(input.max, 10) ? Infinity : pv;
      }
    }

    drawer.querySelectorAll('.cf-slider-input').forEach(function (input) {
      input.addEventListener('input', function () {
        updateSlider(this);
        applyFilters();
      });
      updateSlider(input);
    });

    /* ────────────────── Toggle (trailer) ───────────────────── */
    var trailerToggle = drawer.querySelector('[data-filter="trailer"]');
    if (trailerToggle) {
      trailerToggle.addEventListener('click', function () {
        state.trailer = this.getAttribute('aria-checked') !== 'true';
        this.setAttribute('aria-checked', state.trailer ? 'true' : 'false');
        applyFilters();
      });
    }

    /* ────────────────── Active filter chips ────────────────── */
    function renderActiveFilterTags() {
      var container = document.querySelector('[data-active-filters]');
      if (!container) return;

      /* Remove previously injected JS chips only */
      container.querySelectorAll('[data-js-chip]').forEach(function (el) { el.remove(); });

      var closeIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="collection-section__filter-chip__close-icon"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';

      function makeChip(label, onRemove) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'collection-section__filter-chip';
        chip.dataset.jsChip = '1';
        chip.setAttribute('aria-label', 'Remove ' + label + ' filter');
        chip.innerHTML = '<span>' + label + '</span>' + closeIcon;
        chip.addEventListener('click', onRemove);
        container.appendChild(chip);
      }

      /* Brands */
      state.brands.forEach(function (brand) {
        makeChip(brand, function () {
          state.brands.delete(brand);
          drawer.querySelectorAll('[data-filter="brands"]').forEach(function (pill) {
            if ((pill.dataset.value || '').toLowerCase() === brand.toLowerCase()) deactivatePill(pill);
          });
          applyFilters();
        });
      });

      /* Lifestyle */
      state.lifestyle.forEach(function (key) {
        var btn = drawer.querySelector('[data-filter="lifestyle"][data-value="' + key + '"]');
        var label = btn ? (btn.querySelector('.cf-option-text') || {}).textContent || key : key;
        makeChip(label, function () {
          state.lifestyle.delete(key);
          if (btn) btn.setAttribute('aria-pressed', 'false');
          applyFilters();
        });
      });

      /* Condition */
      if (state.condition && state.condition !== 'all') {
        var condLabel = state.condition.replace(/-/g, ' ');
        condLabel = condLabel.charAt(0).toUpperCase() + condLabel.slice(1);
        makeChip(condLabel, function () {
          state.condition = 'all';
          drawer.querySelectorAll('.cf-radio-btn').forEach(function (b, i) {
            var first = i === 0;
            b.setAttribute('aria-pressed', first ? 'true' : 'false');
            var ind = b.querySelector('.cf-radio-indicator');
            if (ind) {
              if (first) { ind.classList.add('cf-radio-indicator--checked'); ind.innerHTML = '<span class="cf-radio-dot"></span>'; }
              else { ind.classList.remove('cf-radio-indicator--checked'); ind.innerHTML = ''; }
            }
          });
          applyFilters();
        });
      }

      /* Product type */
      state.productType.forEach(function (type) {
        makeChip(type, function () {
          state.productType.delete(type);
          drawer.querySelectorAll('[data-filter="product-type"]').forEach(function (pill) {
            if ((pill.dataset.value || '').toLowerCase() === type.toLowerCase()) deactivatePill(pill);
          });
          if (state.productType.size === 0) {
            var va = drawer.querySelector('[data-filter="product-type"][data-value=""]');
            if (va) activatePill(va, 'product-type');
          }
          applyFilters();
        });
      });

      /* Keyword */
      if (state.keyword) {
        makeChip('“' + state.keyword + '”', function () {
          state.keyword = '';
          if (keywordInput) keywordInput.value = '';
          applyFilters();
        });
      }

      /* Length */
      var lenInput = drawer.querySelector('[data-filter="length"]');
      if (lenInput && isFinite(state.length)) {
        makeChip('Length' + state.length + 'ft', function () {
          lenInput.value = lenInput.max;
          updateSlider(lenInput);
          applyFilters();
        });
      }

      /* Price */
      var priceInp = drawer.querySelector('[data-filter="price"]');
      if (priceInp && isFinite(state.price)) {
        makeChip('Price up to ' + formatPrice(state.price), function () {
          priceInp.value = priceInp.max;
          updateSlider(priceInp);
          applyFilters();
        });
      }

      /* Trailer */
      if (state.trailer) {
        makeChip('Trailer Included', function () {
          state.trailer = false;
          if (trailerToggle) trailerToggle.setAttribute('aria-checked', 'false');
          applyFilters();
        });
      }
    }

    /* ────────────────── Apply filters ──────────────────────── */
    function applyFilters() {
      var visible = 0;
      var total = $('[data-product-total]').data('product-total');

      if (isAnyFilterActive()) {
        if (allProductCards) {
          /* Filter across every product in the collection, not just the
             currently-displayed page of the 12-per-page grid. */
          var matches = allProductCards.filter(cardMatchesState);
          renderGridCards(matches.map(function (card) { return card.cloneNode(true); }));
          visible = matches.length;
        } else {
          /* Full scan hasn't finished loading yet — filter only what's on
             screen so the UI still responds; applyFilters() runs again with
             the complete set as soon as the scan resolves. */
          var cards = gridContainer ? gridContainer.querySelectorAll('[data-product-card]') : [];
          cards.forEach(function (card) {
            var show = cardMatchesState(card);
            card.style.display = show ? '' : 'none';
            if (show) visible++;
          });
        }
        if (paginationNav) paginationNav.hidden = true;
      } else {
        restoreOriginalGrid();
        if (gridContainer) {
          gridContainer.querySelectorAll('[data-product-card]').forEach(function (card) {
            card.style.display = '';
            visible++;
          });
        }
        if (paginationNav) paginationNav.hidden = false;
      }

      var countEl = document.querySelector('[data-product-count]');
      if (countEl) countEl.textContent = 'Showing ' + visible + ' of ' + total;

      renderActiveFilterTags();
    }

    /* ────────────────── Clear helpers ──────────────────────── */
    drawer.querySelectorAll('[data-clear-group]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = this.dataset.clearGroup;
        clearGroup(group);
        applyFilters();
      });
    });

    function clearGroup(group) {
      if (group === 'lifestyle') {
        state.lifestyle.clear();
        drawer.querySelectorAll('[data-filter="lifestyle"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
      } else if (group === 'condition') {
        state.condition = 'all';
        drawer.querySelectorAll('.cf-radio-btn').forEach(function (b, i) {
          var isFirst = i === 0;
          b.setAttribute('aria-pressed', isFirst ? 'true' : 'false');
          var ind = b.querySelector('.cf-radio-indicator');
          if (ind) {
            if (isFirst) { ind.classList.add('cf-radio-indicator--checked'); ind.innerHTML = '<span class="cf-radio-dot"></span>'; }
            else { ind.classList.remove('cf-radio-indicator--checked'); ind.innerHTML = ''; }
          }
        });
      } else if (group === 'brands') {
        state.brands.clear();
        drawer.querySelectorAll('[data-filter="brands"]').forEach(deactivatePill);
      } else if (group === 'keyword') {
        state.keyword = '';
        if (keywordInput) keywordInput.value = '';
      } else if (group === 'length') {
        var li = drawer.querySelector('[data-filter="length"]');
        if (li) { li.value = li.max; updateSlider(li); }
      } else if (group === 'price') {
        var pi = drawer.querySelector('[data-filter="price"]');
        if (pi) { pi.value = pi.max; updateSlider(pi); }
      } else if (group === 'product-type') {
        state.productType.clear();
        drawer.querySelectorAll('[data-filter="product-type"]').forEach(deactivatePill);
        var va = drawer.querySelector('[data-filter="product-type"][data-value=""]');
        if (va) activatePill(va, 'product-type');
      } else if (group === 'trailer') {
        state.trailer = false;
        if (trailerToggle) trailerToggle.setAttribute('aria-checked', 'false');
      }
    }

    var clearAllBtn = drawer.querySelector('[data-clear-all]');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        ['lifestyle','condition','brands','keyword','length','price','product-type','trailer'].forEach(clearGroup);
        applyFilters();
      });
    }

    /* ────────────────── Sort dropdown ───────────────────────── */
    var sortToggle = document.querySelector('.collection-section__sort-toggle');
    var sortDropdown = document.getElementById('collection-sort-dropdown');
    if (sortToggle && sortDropdown) {
      sortToggle.addEventListener('click', function () {
        var open = sortDropdown.classList.toggle('hidden');
        sortToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
      document.addEventListener('click', function (e) {
        if (!sortToggle.contains(e.target) && !sortDropdown.contains(e.target)) {
          sortDropdown.classList.add('hidden');
          sortToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ────────────────── Image carousel ─────────────────────── */
    initCardCarousels(document);

    /* ────────────────── Init from URL parameters ───────────── */
    function initFiltersFromURL() {
      var params = new URLSearchParams(window.location.search);
      var brandParam = params.get('brand');
      if (!brandParam) return;

      brandParam.split(',').forEach(function (raw) {
        var val = raw.trim().toLowerCase();
        if (!val) return;
        drawer.querySelectorAll('[data-filter="brands"]').forEach(function (pill) {
          if ((pill.dataset.value || '').toLowerCase() === val) {
            activatePill(pill, 'brands');
            state.brands.add(val);
          }
        });
      });
    }

    /* ────────────────── Init ───────────────────────────────── */
    populateFilters();
    initFiltersFromURL();
    applyFilters();
    loadAllProducts();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection_v2"] && !Shopify.designMode) return;
  try {
    
  (function () {

    var drawer = document.getElementById('cv2-filter-drawer');
    var toggleBtn = document.querySelector('.cv2-filter-toggle');
    if (!drawer) return;

    /* ────────────── Drawer open / close ────────────── */
    function openDrawer() {
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('collection-filter--open');
      });
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('collection-filter--open');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 300);
    }

    if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);

    drawer.querySelectorAll('[data-close-drawer]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* ────────────── Filter state ────────────────────── */
    var state = {
      productType: new Set(),
      brands: new Set(),
      keyword: '',
      stock: new Set(),
      offer: 'all',
      price: Infinity
    };

    /* Stock options are fixed so they always show, even before any product has custom.stock set */
    var STOCK_OPTIONS = ['Available to order', 'In Stock', 'On Backorder-out of stock'];

    /* Checkbox groups → their state Set */
    var checkboxState = {
      'product-type': state.productType,
      'stock': state.stock
    };

    function parseMeta(raw) {
      if (!raw) return [];
      var trimmed = raw.trim();
      if (trimmed.charAt(0) === '[') {
        try {
          var arr = JSON.parse(trimmed);
          return Array.isArray(arr) ? arr.map(function (v) { return String(v).trim(); }) : [String(arr).trim()];
        } catch (e) { /* fall through */ }
      }
      return trimmed.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }

    /* ────────────── Populate dynamic filter options ── */
    function populateFilters() {
      var cards = document.querySelectorAll('[data-product-card]');
      var productTypes = new Map();
      var brands = new Set();
      var offers = new Map();

      cards.forEach(function (card) {
        parseMeta(card.dataset.productType).forEach(function (t) { if (t) productTypes.set(t.toLowerCase(), t); });
        parseMeta(card.dataset.brands).forEach(function (b) { if (b) brands.add(b); });
        parseMeta(card.dataset.offer).forEach(function (o) { if (o) offers.set(o.toLowerCase(), o); });
      });

      var ptTarget = drawer.querySelector('[data-options-target="product-type"]');
      if (ptTarget) {
        productTypes.forEach(function (label, key) {
          ptTarget.appendChild(makeCheckbox(label, key, 'product-type'));
        });
      }

      var stockTarget = drawer.querySelector('[data-options-target="stock"]');
      if (stockTarget) {
        STOCK_OPTIONS.forEach(function (label) {
          stockTarget.appendChild(makeCheckbox(label, label.toLowerCase(), 'stock'));
        });
      }

      var brandsTarget = drawer.querySelector('[data-options-target="brands"]');
      if (brandsTarget) {
        brandsTarget.appendChild(makePill('View All', 'brands'));
        brands.forEach(function (brand) {
          brandsTarget.appendChild(makePill(brand, 'brands'));
        });
        var viewAll = brandsTarget.querySelector('.cf-pill');
        if (viewAll) activatePill(viewAll);
      }

      var offerTarget = drawer.querySelector('[data-options-target="offer"]');
      if (offerTarget) {
        offerTarget.appendChild(makeRadio('All', 'all', true));
        offers.forEach(function (label, key) {
          offerTarget.appendChild(makeRadio(label, key, false));
        });
      }
    }

    function makeCheckbox(label, value, group) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cf-checkbox-btn';
      btn.setAttribute('aria-pressed', 'false');
      btn.dataset.filter = group;
      btn.dataset.value = value;
      btn.innerHTML = '<span class="cf-checkbox-box"></span><span class="cf-option-text">' + label + '</span>';
      btn.addEventListener('click', function () { toggleCheckbox(this); });
      return btn;
    }

    function makePill(label, group) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cf-pill';
      btn.textContent = label;
      btn.setAttribute('aria-pressed', 'false');
      btn.dataset.filter = group;
      btn.dataset.value = label === 'View All' ? '' : label.toLowerCase();
      btn.addEventListener('click', function () { togglePill(this, group); });
      return btn;
    }

    function makeRadio(label, value, checked) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cf-radio-btn' + (checked ? ' cf-radio-btn--checked' : '');
      btn.dataset.filter = 'offer';
      btn.dataset.value = value;
      btn.setAttribute('aria-pressed', checked ? 'true' : 'false');
      btn.innerHTML =
        '<span class="cf-radio-indicator' + (checked ? ' cf-radio-indicator--checked' : '') + '">' +
        (checked ? '<span class="cf-radio-dot"></span>' : '') +
        '</span><span class="cf-option-text">' + label + '</span>';
      btn.addEventListener('click', function () { selectRadio(this); });
      return btn;
    }

    /* ────────────── Checkbox toggle (product type, stock) ── */
    function toggleCheckbox(btn) {
      var pressed = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      var val = btn.dataset.value;
      var set = checkboxState[btn.dataset.filter];
      if (pressed) { set.delete(val); } else { set.add(val); }
      applyFilters();
    }

    /* ────────────── Keyword ─────────────────────────── */
    var keywordInput = drawer.querySelector('[data-filter="keyword"]');
    if (keywordInput) {
      keywordInput.addEventListener('input', function () {
        state.keyword = normalizeText(this.value);
        applyFilters();
      });
    }

    /* Lowercase, strip accents/punctuation and collapse spaces so "Stabi-craft  1850" ≈ "stabi craft 1850" */
    function normalizeText(str) {
      return String(str || '')
        .toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    /* Every word typed must appear in the product title (any order) */
    function matchesKeyword(card) {
      if (!state.keyword) return true;
      var title = ' ' + normalizeText(card.dataset.title) + ' ';
      return state.keyword.split(' ').every(function (word) {
        return title.indexOf(word) !== -1;
      });
    }

    /* ────────────── Radio (offer) ───────────────────── */
    function selectRadio(btn) {
      drawer.querySelectorAll('[data-filter="offer"]').forEach(function (b) {
        b.setAttribute('aria-pressed', 'false');
        b.classList.remove('cf-radio-btn--checked');
        var ind = b.querySelector('.cf-radio-indicator');
        if (ind) { ind.classList.remove('cf-radio-indicator--checked'); ind.innerHTML = ''; }
      });
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.add('cf-radio-btn--checked');
      var ind = btn.querySelector('.cf-radio-indicator');
      if (ind) {
        ind.classList.add('cf-radio-indicator--checked');
        ind.innerHTML = '<span class="cf-radio-dot"></span>';
      }
      state.offer = btn.dataset.value;
      applyFilters();
    }

    /* ────────────── Pill toggle (brands) ────────────── */
    function activatePill(pill) {
      pill.setAttribute('aria-pressed', 'true');
      pill.classList.add('cf-pill--active');
    }

    function deactivatePill(pill) {
      pill.setAttribute('aria-pressed', 'false');
      pill.classList.remove('cf-pill--active');
    }

    function togglePill(pill, group) {
      var val = pill.dataset.value;

      if (val === '') {
        drawer.querySelectorAll('[data-filter="' + group + '"]').forEach(deactivatePill);
        activatePill(pill);
        state[group].clear();
      } else {
        var viewAll = drawer.querySelector('[data-filter="' + group + '"][data-value=""]');
        if (viewAll) deactivatePill(viewAll);
        var isActive = pill.getAttribute('aria-pressed') === 'true';
        if (isActive) { deactivatePill(pill); state[group].delete(val); }
        else { activatePill(pill); state[group].add(val); }
        if (state[group].size === 0 && viewAll) activatePill(viewAll);
      }
      applyFilters();
    }

    /* ────────────── Range slider (price) ────────────── */
    /* The slider runs on a cubic curve so the lower end has fine resolution
       (e.g. $5 steps under $100) while still reaching the collection's top price. */
    var PRICE_CURVE = 3;

    function roundPrice(v) {
      if (v < 20) return Math.ceil(v);
      if (v < 100) return Math.ceil(v / 5) * 5;
      if (v < 500) return Math.ceil(v / 10) * 10;
      if (v < 2000) return Math.ceil(v / 50) * 50;
      if (v < 10000) return Math.ceil(v / 100) * 100;
      return Math.ceil(v / 500) * 500;
    }

    function sliderToPrice(input) {
      var pos = parseInt(input.value, 10);
      var maxPos = parseInt(input.max, 10);
      if (pos >= maxPos) return Infinity;
      var maxPrice = parseFloat(input.dataset.priceMax) || 15000;
      return Math.min(roundPrice(maxPrice * Math.pow(pos / maxPos, PRICE_CURVE)), maxPrice);
    }

    function formatPrice(v) {
      if (v >= 1000) return '$' + (Math.round(v / 100) / 10).toString().replace(/\.0$/, '') + 'k';
      return '$' + v;
    }

    function updateSlider(input) {
      var key = input.dataset.filter;
      var pct = ((input.value - input.min) / (input.max - input.min)) * 100;
      var fill = drawer.querySelector('[data-slider-fill="' + key + '"]');
      var valEl = drawer.querySelector('[data-slider-val="' + key + '"]');
      if (fill) fill.style.width = pct + '%';
      if (key === 'price') {
        state.price = sliderToPrice(input);
        if (valEl) valEl.textContent = isFinite(state.price) ? formatPrice(state.price) : 'Any';
      }
    }

    function updateAllSliders() {
      drawer.querySelectorAll('.cf-slider-input').forEach(function (input) {
        updateSlider(input);
      });
    }

    drawer.querySelectorAll('.cf-slider-input').forEach(function (input) {
      input.addEventListener('input', function () {
        updateSlider(this);
        applyFilters();
      });
    });

    /* ────────────── Apply filters ───────────────────── */
    function applyFilters() {
      var cards = document.querySelectorAll('[data-product-card]');
      var visible = 0;
      var countEl = document.querySelector('[data-product-count]');
      var total = countEl ? parseInt(countEl.dataset.cv2Total, 10) || cards.length : cards.length;

      cards.forEach(function (card) {
        var show = true;

        if (state.productType.size > 0) {
          var cardTypes = parseMeta(card.dataset.productType).map(function (t) { return t.toLowerCase(); });
          var matched = false;
          state.productType.forEach(function (t) { if (cardTypes.indexOf(t) !== -1) matched = true; });
          if (!matched) show = false;
        }
        if (show && state.brands.size > 0) {
          var cardBrands = parseMeta(card.dataset.brands).map(function (b) { return b.toLowerCase(); });
          var matched = false;
          state.brands.forEach(function (b) { if (cardBrands.indexOf(b.toLowerCase()) !== -1) matched = true; });
          if (!matched) show = false;
        }
        if (show && !matchesKeyword(card)) show = false;
        if (show && state.stock.size > 0) {
          var cardStock = parseMeta(card.dataset.stock).map(function (s) { return s.toLowerCase(); });
          var matched = false;
          state.stock.forEach(function (s) { if (cardStock.indexOf(s) !== -1) matched = true; });
          if (!matched) show = false;
        }
        if (show && state.offer && state.offer !== 'all') {
          var cardOffers = parseMeta(card.dataset.offer).map(function (o) { return o.toLowerCase(); });
          if (cardOffers.indexOf(state.offer) === -1) show = false;
        }
        if (show && isFinite(state.price)) {
          var price = parseFloat(card.dataset.price || 0);
          if (price > state.price) show = false;
        }

        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      if (countEl) countEl.textContent = 'Showing ' + visible + ' of ' + total;
      renderActiveTags();
    }

    /* ────────────── Active filter chips ─────────────── */
    function renderActiveTags() {
      var container = document.querySelector('[data-active-tags]');
      if (!container) return;
      container.innerHTML = '';

      function addChip(label, onClear) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cv2-active-chip';
        var text = document.createElement('span');
        text.textContent = label;
        btn.appendChild(text);
        btn.insertAdjacentHTML('beforeend',
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
          '<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>' +
          '</svg>');
        btn.addEventListener('click', function () { onClear(); applyFilters(); });
        container.appendChild(btn);
      }

      state.productType.forEach(function (val) {
        var labelEl = drawer.querySelector('[data-filter="product-type"][data-value="' + val + '"] .cf-option-text');
        addChip(labelEl ? labelEl.textContent : val, function () {
          state.productType.delete(val);
          var b = drawer.querySelector('[data-filter="product-type"][data-value="' + val + '"]');
          if (b) b.setAttribute('aria-pressed', 'false');
        });
      });

      state.brands.forEach(function (val) {
        addChip(val, function () {
          state.brands.delete(val);
          var pill = drawer.querySelector('[data-filter="brands"][data-value="' + val.toLowerCase() + '"]');
          if (pill) deactivatePill(pill);
          if (state.brands.size === 0) {
            var va = drawer.querySelector('[data-filter="brands"][data-value=""]');
            if (va) activatePill(va);
          }
        });
      });

      if (state.keyword) {
        addChip('“' + state.keyword + '”', function () {
          state.keyword = '';
          if (keywordInput) keywordInput.value = '';
        });
      }

      state.stock.forEach(function (val) {
        var labelEl = drawer.querySelector('[data-filter="stock"][data-value="' + val + '"] .cf-option-text');
        addChip(labelEl ? labelEl.textContent : val, function () {
          state.stock.delete(val);
          var b = drawer.querySelector('[data-filter="stock"][data-value="' + val + '"]');
          if (b) b.setAttribute('aria-pressed', 'false');
        });
      });

      if (state.offer && state.offer !== 'all') {
        var offerLabelEl = drawer.querySelector('[data-filter="offer"][data-value="' + state.offer + '"] .cf-option-text');
        addChip(offerLabelEl ? offerLabelEl.textContent : state.offer, function () {
          var allBtn = drawer.querySelector('[data-filter="offer"][data-value="all"]');
          if (allBtn) selectRadio(allBtn);
        });
      }

      var priceInput = drawer.querySelector('[data-filter="price"]');
      if (priceInput && isFinite(state.price)) {
        addChip('Price up to ' + formatPrice(state.price), function () {
          priceInput.value = priceInput.max;
          updateSlider(priceInput);
        });
      }
    }

    /* ────────────── Clear helpers ───────────────────── */
    drawer.querySelectorAll('[data-clear-group]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        clearGroup(this.dataset.clearGroup);
        applyFilters();
      });
    });

    function clearGroup(group) {
      if (group === 'product-type') {
        state.productType.clear();
        drawer.querySelectorAll('[data-filter="product-type"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
      } else if (group === 'brands') {
        state.brands.clear();
        drawer.querySelectorAll('[data-filter="brands"]').forEach(deactivatePill);
        var va = drawer.querySelector('[data-filter="brands"][data-value=""]');
        if (va) activatePill(va);
      } else if (group === 'keyword') {
        state.keyword = '';
        if (keywordInput) keywordInput.value = '';
      } else if (group === 'stock') {
        state.stock.clear();
        drawer.querySelectorAll('[data-filter="stock"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
      } else if (group === 'offer') {
        var allBtn = drawer.querySelector('[data-filter="offer"][data-value="all"]');
        if (allBtn) selectRadio(allBtn);
      } else if (group === 'price') {
        var pi = drawer.querySelector('[data-filter="price"]');
        if (pi) { pi.value = pi.max; updateSlider(pi); }
      }
    }

    var clearAllBtn = drawer.querySelector('[data-clear-all]');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        ['product-type', 'brands', 'keyword', 'stock', 'offer', 'price'].forEach(clearGroup);
        applyFilters();
      });
    }

    /* ────────────── Sort dropdown ───────────────────── */
    var sortToggle = document.querySelector('.cv2-sort-toggle');
    var sortDropdown = document.getElementById('cv2-sort-dropdown');
    if (sortToggle && sortDropdown) {
      sortToggle.addEventListener('click', function () {
        var nowOpen = !sortDropdown.classList.toggle('hidden');
        sortToggle.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!sortToggle.contains(e.target) && !sortDropdown.contains(e.target)) {
          sortDropdown.classList.add('hidden');
          sortToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ────────────── Load more (append, no page reload) ── */
    var productGrid = document.getElementById('cv2-product-grid');
    var loadMoreWrap = document.getElementById('cv2-load-more-wrap');

    var loadMoreBtn = document.querySelector('[data-load-more]');
    var loadMoreText = loadMoreBtn ? loadMoreBtn.innerHTML : '';
    var loadingPage = null;

    /* Fetches the next page and appends its cards. Resolves true if more pages remain. */
    function loadNextPage() {
      if (loadingPage) return loadingPage;
      var url = loadMoreBtn && loadMoreBtn.dataset.nextUrl;
      if (!url || !productGrid) return Promise.resolve(false);

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'LOADING...';

      loadingPage = fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('cv2-product-grid');
          if (newGrid) {
            newGrid.querySelectorAll('[data-product-card]').forEach(function (card) {
              productGrid.appendChild(card);
            });
          }

          var newBtn = doc.querySelector('[data-load-more]');
          var hasMore = !!(newBtn && newBtn.dataset.nextUrl);
          if (hasMore) {
            loadMoreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
            loadMoreBtn.disabled = false;
            loadMoreBtn.innerHTML = loadMoreText;
          } else {
            delete loadMoreBtn.dataset.nextUrl;
            if (loadMoreWrap) loadMoreWrap.remove();
          }
          return hasMore;
        })
        .catch(function () {
          loadMoreBtn.disabled = false;
          loadMoreBtn.innerHTML = loadMoreText;
          return false;
        })
        .then(function (hasMore) {
          loadingPage = null;
          /* Run filters over the new cards so non-matching ones stay hidden */
          applyFilters();
          return hasMore;
        });
      return loadingPage;
    }

    /* A keyword search must cover the whole collection, not just the loaded pages */
    function loadAllRemaining() {
      return loadNextPage().then(function (hasMore) {
        if (hasMore && state.keyword) return loadAllRemaining();
      });
    }

    if (loadMoreBtn) loadMoreBtn.addEventListener('click', loadNextPage);
    if (keywordInput) {
      keywordInput.addEventListener('input', function () {
        if (state.keyword) loadAllRemaining();
      });
    }

    /* ────────────── Init ───────────────────────────── */
    populateFilters();
    updateAllSliders();
    applyFilters();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-accordion"] && !Shopify.designMode) return;
  try {
    
(function ($) {
  function initAccordion($section) {
    var $bodies = $section.find('.accordion-item__body');
    $bodies.hide();

    $section.find('.accordion-item__header').on('click', function () {
      var $header = $(this);
      var $item = $header.closest('.accordion-item');
      var $body = $item.find('.accordion-item__body');
      var $chevron = $header.find('.accordion-item__chevron');
      var isOpen = $item.hasClass('is-open');

      // Close all open items in this section
      $section.find('.accordion-item.is-open').each(function () {
        var $open = $(this);
        $open.removeClass('is-open');
        $open.find('.accordion-item__header').attr('aria-expanded', 'false');
        $open.find('.accordion-item__body').slideUp(300);
        $open.find('.accordion-item__chevron').removeClass('rotate-90');
      });

      if (!isOpen) {
        $item.addClass('is-open');
        $header.attr('aria-expanded', 'true');
        $body.slideDown(300);
        $chevron.addClass('rotate-90');
      }
    });
  }

  $(document).ready(function () {
    $('.accordion-section').each(function () {
      initAccordion($(this));
    });
  });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-row"] && !Shopify.designMode) return;
  try {
    
  (function($) {    
    var section = document.querySelector('.content-row');

    // ── Video modal ──
    var playBtn = section.querySelector('.content-row__play-btn');
    if (!playBtn) return;

    var sectionId = playBtn.dataset.sectionId;
    var modal = document.getElementById('content-row-modal-' + sectionId);
    if (!modal) return;

    var iframe = modal.querySelector('.content-row__modal-iframe');
    var closeBtn = modal.querySelector('.content-row__modal-close');

    function getEmbedUrl(url) {
      var youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
      if (youtubeMatch) {
        return 'https://www.youtube.com/embed/' + youtubeMatch[1] + '?autoplay=1';
      }
      var vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
      if (vimeoMatch) {
        return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
      }
      return url;
    }

    function openModal() {
      iframe.src = getEmbedUrl(playBtn.dataset.videoUrl);
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      iframe.src = '';
      document.body.style.overflow = '';
      playBtn.focus();
    }

    playBtn.addEventListener('click', openModal);
    
    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });


  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events"] && !Shopify.designMode) return;
  try {
    
  jQuery(function($) {
    $('[data-events-slider]').each(function() {
      var $slider = $(this);
      var $track = $slider.find('.events-slider__track');
      var $dotsContainer = $slider.find('.events-slider__dots');
      var $prev = $slider.find('.events-slider__arrow--prev');
      var $next = $slider.find('.events-slider__arrow--next');

      function updateArrows(slick) {
        var atStart = slick.currentSlide === 0;
        var atEnd = slick.currentSlide >= slick.slideCount - slick.options.slidesToShow;
        $prev.prop('disabled', atStart);
        $next.prop('disabled', atEnd);
      }

      $track.on('init afterChange', function(e, slick) {
        updateArrows(slick);
      });

      $track.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: true,
        appendDots: $dotsContainer,
        customPaging: function(slider, i) {
          return '<button type="button" aria-label="Page ' + (i + 1) + '"></button>';
        },
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      $prev.on('click', function() { $track.slick('slickPrev'); });
      $next.on('click', function() { $track.slick('slickNext'); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["four-col-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var counters = document.querySelectorAll('.stats-section__count');
    if (!counters.length) return;

    var DURATION = 2000;

    function animateCounter(el) {
      var raw = el.dataset.target;
      var target = parseFloat(raw);
      if (isNaN(target)) {
        el.textContent = raw;
        return;
      }
      var isDecimal = target % 1 !== 0;
      var start = null;

      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / DURATION, 1);
        var ease = 1 - Math.pow(1 - progress, 3);
        var current = target * ease;
        el.textContent = isDecimal
          ? current.toFixed(1)
          : Math.round(current).toLocaleString();
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = isDecimal
            ? target.toFixed(1)
            : target.toLocaleString();
        }
      }

      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.dataset.animated) {
          entry.target.dataset.animated = 'true';
          animateCounter(entry.target);
        }
      });
    }, { threshold: 0.4 });

    counters.forEach(function (el) {
      el.textContent = '0';
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hover-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.hover-card[data-section-id]');
    sections.forEach((section) => {
      const tabs = Array.from(section.querySelectorAll('[data-hover-tab]'));
      const images = Array.from(section.querySelectorAll('[data-hover-image]'));
      if (!tabs.length) return;

      function activate(index) {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          tab.style.backgroundColor = active ? tab.dataset.tabActiveBg : 'transparent';
          tab.style.color = active ? tab.dataset.tabActiveText : tab.dataset.tabIdleText;
        });
        images.forEach((img, i) => {
          const active = i === index;
          img.style.opacity = active ? '1' : '0';
          img.classList.toggle('is-active', active);
        });
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('mouseenter', () => activate(index));
        tab.addEventListener('focus', () => activate(index));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            const next = (index + 1) % tabs.length;
            tabs[next].focus();
          } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const prev = (index - 1 + tabs.length) % tabs.length;
            tabs[prev].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            tabs[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            tabs[tabs.length - 1].focus();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadScript(src, id, onLoad) {
    var existing = document.getElementById(id);
    if (existing) {
      if (existing.dataset.ready) {
        onLoad();
      } else {
        existing.addEventListener('load', onLoad);
      }
      return;
    }
    var el = document.createElement('script');
    el.id = id;
    el.src = src;
    el.onload = function () {
      el.dataset.ready = '1';
      onLoad();
    };
    document.head.appendChild(el);
  }

  function initSliders() {
    document.querySelectorAll('.image-slider__slider').forEach(function (sliderEl) {
      if (sliderEl.classList.contains('slick-initialized')) return;
      var section = sliderEl.closest('.image-slider');
      var prevBtn = section ? section.querySelector('[data-slider-prev]') : null;
      var nextBtn = section ? section.querySelector('[data-slider-next]') : null;
      var dotsWrap = section ? section.querySelector('[data-slider-dots]') : null;
      var autoplay = section ? section.dataset.autoplay === 'true' : false;
      var autoplaySpeed = section ? parseInt(section.dataset.autoplaySpeed || '5000', 10) : 5000;

      window.jQuery(sliderEl).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        dots: dotsWrap !== null,
        appendDots: dotsWrap ? window.jQuery(dotsWrap) : false,
        arrows: prevBtn !== null,
        prevArrow: prevBtn ? window.jQuery(prevBtn) : false,
        nextArrow: nextBtn ? window.jQuery(nextBtn) : false,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        pauseOnHover: true,
        pauseOnFocus: true
      });
    });
  }

  initSliders();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locations"] && !Shopify.designMode) return;
  try {
    
(function ($) {
  function initLocations($section) {
    var $tabs   = $section.find('.location-tab');
    var $frames = $section.find('.location-map-frame');

    function activate(index) {
      $tabs.each(function (i) {
        $(this).toggleClass('is-active', i === index);
      });
      $frames.each(function (i) {
        $(this).toggleClass('is-active', i === index);
      });
    }

    $tabs.on('mouseenter', function () {
      activate(parseInt($(this).data('index'), 10));
    });
  }

  $(document).ready(function () {
    $('.locations-section').each(function () {
      initLocations($(this));
    });
  });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSliders() {
    document.querySelectorAll('.product-sale__slider').forEach(function (sliderEl) {
      if (sliderEl.classList.contains('slick-initialized')) return;
      var wrap = sliderEl.closest('.product-sale');
      var prevBtn = wrap ? wrap.querySelector('[data-product-sale-prev]') : null;
      var nextBtn = wrap ? wrap.querySelector('[data-product-sale-next]') : null;
      var dotsWrap = wrap ? wrap.querySelector('[data-product-sale-dots]') : null;

      console.log('dotsWrap',dotsWrap);
      console.log('count', window.jQuery(dotsWrap).find('li').length);

      window.jQuery(sliderEl).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        appendDots: dotsWrap ? window.jQuery(dotsWrap) : false,
        prevArrow: prevBtn ? window.jQuery(prevBtn) : '<button type="button" class="slick-prev">Previous</button>',
        nextArrow: nextBtn ? window.jQuery(nextBtn) : '<button type="button" class="slick-next">Next</button>',
        responsive: [
          { breakpoint: 1280, settings: { slidesToShow: 3 } },
          { breakpoint: 1024, settings: { slidesToShow: 2 } },
          { breakpoint: 640,  settings: { slidesToShow: 1 } }
        ]
      });
    });
  }

  function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sale-add-to-cart]');
      if (!btn || btn.disabled) return;

      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) {
        window.location.href = btn.dataset.productUrl;
        return;
      }

      btn.disabled = true;
      btn.textContent = btn.dataset.labelAdding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart_error');
          return res.json();
        })
        .then(function () {
          btn.textContent = btn.dataset.labelAdded;
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          setTimeout(function () {
            btn.textContent = btn.dataset.labelDefault;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          window.location.href = btn.dataset.productUrl;
        });
    });
  }

  initSliders();
  initAddToCart();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-explore"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadScript(src, id, onLoad) {
    var existing = document.getElementById(id);
    if (existing) {
      if (existing.dataset.ready) {
        onLoad();
      } else {
        existing.addEventListener('load', onLoad);
      }
      return;
    }
    var el = document.createElement('script');
    el.id = id;
    el.src = src;
    el.onload = function () {
      el.dataset.ready = '1';
      onLoad();
    };
    document.head.appendChild(el);
  }

  function initSliders() {
    document.querySelectorAll('.product-explore__slider').forEach(function (sliderEl) {
      if (sliderEl.classList.contains('slick-initialized')) return;
      var wrap = sliderEl.closest('.product-explore');
      var prevBtn = wrap ? wrap.querySelector('[data-product-prev]') : null;
      var nextBtn = wrap ? wrap.querySelector('[data-product-next]') : null;
      var dotsWrap = wrap ? wrap.querySelector('[data-product-dots]') : null;

      window.jQuery(sliderEl).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: true,
        appendDots: dotsWrap ? window.jQuery(dotsWrap) : false,
        prevArrow: prevBtn ? window.jQuery(prevBtn) : '<button type="button" class="slick-prev">Previous</button>',
        nextArrow: nextBtn ? window.jQuery(nextBtn) : '<button type="button" class="slick-next">Next</button>',
        responsive: [
          { breakpoint: 1410, settings: { slidesToShow: 3, slidesToScroll: 3 } },
          { breakpoint: 1110, settings: { slidesToShow: 2, slidesToScroll: 2 } },
          { breakpoint: 767,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
      });
    });
  }

  initSliders();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommend"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSliders() {
    document.querySelectorAll('.product-sale__slider').forEach(function (sliderEl) {
      if (sliderEl.classList.contains('slick-initialized')) return;
      var wrap = sliderEl.closest('.product-sale');
      var prevBtn = wrap ? wrap.querySelector('[data-product-sale-prev]') : null;
      var nextBtn = wrap ? wrap.querySelector('[data-product-sale-next]') : null;
      var dotsWrap = wrap ? wrap.querySelector('[data-product-sale-dots]') : null;

      console.log('dotsWrap',dotsWrap);
      console.log('count', window.jQuery(dotsWrap).find('li').length);

      window.jQuery(sliderEl).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: true,
        appendDots: dotsWrap ? window.jQuery(dotsWrap) : false,
        prevArrow: prevBtn ? window.jQuery(prevBtn) : '<button type="button" class="slick-prev">Previous</button>',
        nextArrow: nextBtn ? window.jQuery(nextBtn) : '<button type="button" class="slick-next">Next</button>',
        responsive: [
          { breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 3 } },
          { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false } },
          { breakpoint: 640,  settings: { slidesToShow: 1, slidesToScroll: 1, dots: false } }
        ]
      });
    });
  }

  function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sale-add-to-cart]');
      if (!btn || btn.disabled) return;

      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) {
        window.location.href = btn.dataset.productUrl;
        return;
      }

      btn.disabled = true;
      btn.textContent = btn.dataset.labelAdding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart_error');
          return res.json();
        })
        .then(function () {
          btn.textContent = btn.dataset.labelAdded;
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          setTimeout(function () {
            btn.textContent = btn.dataset.labelDefault;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          window.location.href = btn.dataset.productUrl;
        });
    });
  }

  initSliders();
  initAddToCart();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specifications"] && !Shopify.designMode) return;
  try {
    
(function($){
  $('.product-spec-btn').on('click', function() {
    let $this = $(this).closest('.product-spec-item')
    if ($this.hasClass('open')) {
      $('.product-spec-item').removeClass('open');
      $('.product-spec-panel').slideUp();
    } else {
      $('.product-spec-item').removeClass('open');
      $this.addClass('open');
      $('.product-spec-panel').hide();
      $this.find('.product-spec-panel').slideDown();
    }
    
  });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  // Gallery lightbox
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var sectionId = gallery.dataset.productGallery;
    var lightbox = document.getElementById('product-lightbox-' + sectionId);
    if (!lightbox) return;

    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery-item'));
    var images = items.map(function (item) {
      var img = item.querySelector('img');
      return {
        full: item.dataset.full,
        alt: img ? img.alt : ''
      };
    });

    var lightboxImg = lightbox.querySelector('.product-lightbox-img');
    var counter = lightbox.querySelector('.product-lightbox-counter');
    var closeBtn = lightbox.querySelector('.product-lightbox-close');
    var prevBtn = lightbox.querySelector('.product-lightbox-prev');
    var nextBtn = lightbox.querySelector('.product-lightbox-next');
    var currentIndex = 0;
    var lastFocused = null;

    function show(index) {
      currentIndex = (index + images.length) % images.length;
      var image = images[currentIndex];
      lightboxImg.src = image.full;
      lightboxImg.alt = image.alt;
      counter.textContent = (currentIndex + 1) + ' / ' + images.length;
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(currentIndex - 1);
      if (e.key === 'ArrowRight') show(currentIndex + 1);
    }

    function open(index) {
      lastFocused = document.activeElement;
      show(index);
      lightbox.classList.remove('hidden');
      lightbox.classList.add('flex');
      closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      lightbox.classList.add('hidden');
      lightbox.classList.remove('flex');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    items.forEach(function (item, i) {
      item.addEventListener('click', function () {
        open(i);
      });
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { show(currentIndex + 1); });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
  });

  // Variant selector: updates price + compare-at price
  document.querySelectorAll('[data-product-variants]').forEach(function (wrap) {
    var sectionId = wrap.dataset.productVariants;
    var variantsJson = document.getElementById('product-variants-json-' + sectionId);
    var variantsData = [];
    if (variantsJson) {
      try { variantsData = JSON.parse(variantsJson.textContent); } catch (e) {}
    }
    if (!variantsData.length) return;

    var container = wrap.parentElement;
    var priceEl = container.querySelector('[data-product-price]');
    var compareEl = container.querySelector('[data-product-compare-price]');

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
    }

    // Track current selections: { position: value }, seeded from the pre-selected controls
    var selectedOptions = {};
    wrap.querySelectorAll('.product-option-pill[aria-pressed="true"], select[data-option-position]').forEach(function (el) {
      selectedOptions[parseInt(el.dataset.optionPosition, 10)] = el.tagName === 'SELECT' ? el.value : el.dataset.value;
    });

    function findVariant() {
      return variantsData.find(function (v) {
        return v.options.every(function (val, i) {
          return val === selectedOptions[i + 1];
        });
      });
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
    }

    // Pill buttons
    wrap.querySelectorAll('.product-option-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(this.dataset.optionPosition, 10);
        var val = this.dataset.value;
        selectedOptions[pos] = val;
        wrap.querySelectorAll('.product-option-pill[data-option-position="' + pos + '"]').forEach(function (b) {
          var isActive = b.dataset.value === val;
          b.classList.toggle('bg-[var(--color-sea-mist)]', isActive);
          b.classList.toggle('text-[var(--color-blue)]', isActive);
          b.classList.toggle('bg-transparent', !isActive);
          b.classList.toggle('text-[var(--color-sea-mist)]', !isActive);
          b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        updateVariant();
      });
    });

    // Select dropdowns
    wrap.querySelectorAll('select[data-option-position]').forEach(function (el) {
      el.addEventListener('change', function () {
        selectedOptions[parseInt(this.dataset.optionPosition, 10)] = this.value;
        updateVariant();
      });
    });
  });

  // Tab switching
  // document.querySelectorAll('[data-tabs]').forEach(function (tabGroup) {
  //   var btns = tabGroup.querySelectorAll('.product-tab-btn');
  //   var panels = tabGroup.querySelectorAll('.product-tab-panel');
  //   btns.forEach(function (btn) {
  //     btn.addEventListener('click', function () {
  //       btns.forEach(function (b) {
  //         b.classList.remove('text-white', 'border-white');
  //         b.classList.add('text-white/50', 'border-transparent');
  //         b.setAttribute('aria-selected', 'false');
  //       });
  //       this.classList.remove('text-white/50', 'border-transparent');
  //       this.classList.add('text-white', 'border-white');
  //       this.setAttribute('aria-selected', 'true');
  //       var targetId = this.dataset.tab;
  //       panels.forEach(function (p) {
  //         p.classList.add('hidden');
  //         p.setAttribute('aria-hidden', 'true');
  //       });
  //       var target = document.getElementById(targetId);
  //       if (target) {
  //         target.classList.remove('hidden');
  //         target.removeAttribute('aria-hidden');
  //       }
  //     });
  //   });
  // });

  $('.product-finance-calculator button').on('click', function() {
      let id = $(this).data('tab');
      $(this).toggleClass('open').toggleClass('border-white');
      $('.product-tab-panel#'+id).slideToggle();
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_v2"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ──────────── Image gallery ──────────── */
  var galleryImgs = document.querySelectorAll('[data-gallery-img]');
  var galleryDots = document.querySelectorAll('[data-gallery-dot]');
  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');
  var currentIdx = 0;

  function showGalleryImg(idx) {
    if (!galleryImgs.length) return;
    currentIdx = (idx + galleryImgs.length) % galleryImgs.length;
    galleryImgs.forEach(function (img, i) {
      img.classList.toggle('opacity-0', i !== currentIdx);
      img.classList.toggle('pointer-events-none', i !== currentIdx);
    });
    galleryDots.forEach(function (dot, i) {
      dot.classList.toggle('bg-[#0053c2]', i === currentIdx);
      dot.classList.toggle('bg-[#cce0f4]', i !== currentIdx);
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { showGalleryImg(currentIdx - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showGalleryImg(currentIdx + 1); });
  galleryDots.forEach(function (dot) {
    dot.addEventListener('click', function () { showGalleryImg(parseInt(this.dataset.galleryDot, 10)); });
  });

  /* ──────────── Variant selector ──────────── */
  var form = document.getElementById('pv2-product-form');
  var variantIdInput = form && form.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-product-price]');
  var discountEl = document.querySelector('[data-product-discount]');
  var skuWrapperEl = document.querySelector('[data-product-sku-wrapper]');
  var skuEl = document.querySelector('[data-product-sku]');

  var variantsData = [];
  var variantsJson = document.getElementById('pv2-variants-json');
  if (variantsJson) {
    try { variantsData = JSON.parse(variantsJson.textContent); } catch (e) {}
  }

  /* Track current selections: { position: value } */
  var selectedOptions = {};

  /* Seed from the pre-selected variant (matches the server-rendered selection) */
  var optionCount = 0;
  if (variantsData.length > 0) {
    var initialId = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
    var defaultVariant = variantsData.find(function (v) { return v.id === initialId; }) || variantsData[0];
    optionCount = defaultVariant.options.length;
    defaultVariant.options.forEach(function (val, i) {
      selectedOptions[i + 1] = val;
    });
  }

  /* True if a variant exists with `val` at `pos`, given the selections in earlier options */
  function combinationExists(pos, val) {
    return variantsData.some(function (v) {
      for (var i = 1; i < pos; i++) {
        if (v.options[i - 1] !== selectedOptions[i]) return false;
      }
      return v.options[pos - 1] === val;
    });
  }

  function syncOptionUI(pos) {
    var val = selectedOptions[pos];
    document.querySelectorAll('.pv2-option-pill[data-option-position="' + pos + '"]').forEach(function (b) {
      var isActive = b.dataset.value === val;
      b.classList.toggle('bg-[#0053c2]', isActive);
      b.classList.toggle('text-white', isActive);
      b.classList.toggle('bg-transparent', !isActive);
      b.classList.toggle('text-[#0053c2]', !isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    var select = document.querySelector('select[data-option-position="' + pos + '"]');
    if (select) select.value = val;
  }

  /* Disable values that don't exist for the earlier selections; fall back to the first valid value */
  function refreshOptionAvailability() {
    for (var pos = 2; pos <= optionCount; pos++) {
      var firstValid = null;
      var currentValid = false;
      var els = document.querySelectorAll(
        '.pv2-option-pill[data-option-position="' + pos + '"], select[data-option-position="' + pos + '"] option'
      );
      els.forEach(function (el) {
        var val = el.tagName === 'OPTION' ? el.value : el.dataset.value;
        var exists = combinationExists(pos, val);
        el.disabled = !exists;
        if (el.tagName !== 'OPTION') el.setAttribute('aria-disabled', exists ? 'false' : 'true');
        if (exists && firstValid === null) firstValid = val;
        if (exists && val === selectedOptions[pos]) currentValid = true;
      });
      if (!currentValid && firstValid !== null) selectedOptions[pos] = firstValid;
      syncOptionUI(pos);
    }
  }

  function findVariant() {
    return variantsData.find(function (v) {
      return v.options.every(function (val, i) {
        return val === selectedOptions[i + 1];
      });
    });
  }

  function updateVariant() {
    var variant = findVariant();
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) {
      var cents = variant.price;
      var dollars = (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
      priceEl.textContent = dollars;
    }
    if (discountEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var percentage = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        discountEl.textContent = discountEl.dataset.template.replace('__PERCENTAGE__', percentage);
        discountEl.hidden = false;
      } else {
        discountEl.hidden = true;
      }
    }
    if (skuEl && skuWrapperEl) {
      skuEl.textContent = variant.sku || '';
      skuWrapperEl.hidden = !variant.sku;
    }
  }

  /* Pill buttons */
  document.querySelectorAll('.pv2-option-pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.disabled) return;
      var pos = parseInt(this.dataset.optionPosition, 10);
      selectedOptions[pos] = this.dataset.value;
      syncOptionUI(pos);
      refreshOptionAvailability();
      updateVariant();
    });
  });

  /* Select dropdowns */
  document.querySelectorAll('[data-option-position]').forEach(function (el) {
    if (el.tagName !== 'SELECT') return;
    el.addEventListener('change', function () {
      selectedOptions[parseInt(this.dataset.optionPosition, 10)] = this.value;
      refreshOptionAvailability();
      updateVariant();
    });
  });

  refreshOptionAvailability();

  /* Quantity sync */
  var qtyInput = form && form.querySelector('[data-quantity-input]');
  var qtyHidden = form && form.querySelector('[data-quantity-hidden]');
  if (qtyInput && qtyHidden) {
    qtyInput.addEventListener('input', function () {
      qtyHidden.value = Math.max(1, parseInt(this.value, 10) || 1);
    });
  }

  /* Buy Now */
  var buyNowBtn = document.querySelector('[data-buy-now]');
  if (buyNowBtn && form) {
    buyNowBtn.addEventListener('click', function () {
      var variantId = variantIdInput ? variantIdInput.value : null;
      var qty = qtyHidden ? (parseInt(qtyHidden.value, 10) || 1) : 1;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      }).then(function () {
        window.location.href = '/checkout';
      });
    });
  }

  /* ──────────── Accordion ──────────── */
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (toggle) {
    var body = toggle.nextElementSibling;
    var icon = toggle.querySelector('.pv2-accordion-icon');
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';

    /* Set initial open state */
    if (isOpen && body) {
      body.style.maxHeight = body.scrollHeight + 'px';
      body.classList.add('pv2-accordion-body--open');
      if (icon) icon.classList.add('rotate-180');
    }

    toggle.addEventListener('click', function () {
      isOpen = !isOpen;
      this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (body) {
        if (isOpen) {
          body.style.maxHeight = body.scrollHeight + 'px';
          body.classList.add('pv2-accordion-body--open');
        } else {
          body.style.maxHeight = '0';
          body.classList.remove('pv2-accordion-body--open');
        }
      }
      if (icon) icon.classList.toggle('rotate-180', isOpen);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  /*
   * Filters search results by collection using the `?collection=<handle>` URL param.
   * Liquid search has no collection filter, so when a filter is active every page of
   * results is fetched via the Section Rendering API and non-matching cards are dropped.
   */
  class SearchCollectionFilter extends HTMLElement {
    static MAX_PAGES = 25;

    connectedCallback() {
      const params = new URLSearchParams(window.location.search);
      this.handle = (params.get('collection') || '').trim();

      this.markActiveChip();
      this.syncSearchForm();

      if (this.handle) this.applyFilter();
    }

    markActiveChip() {
      const chips = this.querySelectorAll('[data-collection-chip]');
      let matched = false;

      chips.forEach((chip) => {
        const isActive = chip.dataset.collectionChip === this.handle;
        chip.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive) matched = true;
      });

      // Collection from the URL that isn't in the chip list: add a chip for it.
      if (this.handle && !matched) {
        const nav = this.querySelector('.search-filter-chips');
        if (!nav) return;
        const chip = document.createElement('a');
        chip.className = 'search-filter-chip';
        chip.href = window.location.href;
        chip.dataset.collectionChip = this.handle;
        chip.setAttribute('aria-current', 'true');
        chip.textContent = this.handle.replace(/[-_]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
        nav.appendChild(chip);
      }
    }

    // Keep the collection filter when the shopper runs a new search.
    syncSearchForm() {
      const input = document.querySelector('[data-collection-input]');
      if (!input || !this.handle) return;
      input.value = this.handle;
      input.disabled = false;
    }

    async applyFilter() {
      const grid = this.querySelector('[data-filter-results]');
      if (!grid) return;

      this.setAttribute('data-loading', '');

      const pageSize = parseInt(this.dataset.pageSize, 10) || 20;
      const total = parseInt(this.dataset.resultsCount, 10) || 0;
      const pages = Math.min(Math.ceil(total / pageSize), SearchCollectionFilter.MAX_PAGES);
      const currentPage = parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;

      let cards = Array.from(grid.querySelectorAll('[data-result-card]'));

      try {
        const otherPages = [];
        for (let page = 1; page <= pages; page++) {
          if (page !== currentPage) otherPages.push(this.fetchPageCards(page));
        }
        const fetched = await Promise.all(otherPages);
        cards = cards.concat(...fetched);
      } catch (error) {
        console.error('Search collection filter: failed to load all result pages', error);
      }

      const seen = new Set();
      const matches = cards.filter((card) => {
        const collections = (card.dataset.collections || '').split(/\s+/);
        if (!collections.includes(this.handle)) return false;
        const key = card.getAttribute('href');
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      grid.replaceChildren(...matches);

      const pagination = this.querySelector('[data-filter-pagination]');
      if (pagination) pagination.hidden = true;

      const count = this.querySelector('[data-filter-count]');
      if (count) count.textContent = matches.length === 1 ? '1 result' : `${matches.length} results`;

      const empty = this.querySelector('[data-filter-empty]');
      if (empty) empty.hidden = matches.length > 0;
      grid.hidden = matches.length === 0;

      this.removeAttribute('data-loading');
    }

    async fetchPageCards(page) {
      const url = new URL(window.location.href);
      url.searchParams.set('page', page);
      url.searchParams.delete('collection');
      url.searchParams.set('section_id', this.dataset.sectionId);

      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return Array.from(doc.querySelectorAll('[data-filter-results] [data-result-card]')).map((card) =>
        document.importNode(card, true)
      );
    }
  }

  if (!customElements.get('search-collection-filter')) {
    customElements.define('search-collection-filter', SearchCollectionFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sell-your-boat-form"] && !Shopify.designMode) return;
  try {
    
(function ($) {
  var TOTAL_STEPS = 4;

  function initSYBForm($section) {

    /* ── Show first step, hide rest ── */
    $section.find('.form-step').hide();
    $section.find('.form-step[data-step="1"]').show();

    /* ── Navigate to a step ── */
    function goToStep(step) {
      $section.find('.form-step').hide();
      $section.find('.form-step[data-step="' + step + '"]').show();
      var top = $section.offset().top;
      $('html, body').animate({ scrollTop: Math.max(0, top - 80) }, 350);
    }

    /* ── Validate the visible step's required fields ── */
    function validateStep($step) {
      var valid = true;
      $step.find('[data-required="true"]').each(function () {
        var val = String($(this).val()).trim();
        if (!val) {
          $(this).addClass('is-invalid');
          valid = false;
        } else {
          $(this).removeClass('is-invalid');
        }
      });
      /* Step 1: email (native required handles it, but also check here) */
      var $email = $step.find('#syb-email');
      if ($email.length && !$email.val().trim()) {
        $email.addClass('is-invalid');
        valid = false;
      } else {
        $email.removeClass('is-invalid');
      }
      /* Step 2: a service type must be selected */
      var step = parseInt($step.data('step'));
      if (step === 2) {
        var svc = $section.find('#syb-service-type').val();
        if (!svc) {
          $step.find('.service-options').addClass('syb-options-invalid');
          valid = false;
        } else {
          $step.find('.service-options').removeClass('syb-options-invalid');
        }
      }
      return valid;
    }

    /* ── Next button ── */
    $section.on('click', '.btn-next', function () {
      var $step = $(this).closest('.form-step');
      var step = parseInt($step.data('step'));
      if (validateStep($step) && step < TOTAL_STEPS) {
        goToStep(step + 1);
      }
    });

    /* ── Back button ── */
    $section.on('click', '.btn-back', function () {
      var $step = $(this).closest('.form-step');
      var step = parseInt($step.data('step'));
      if (step > 1) goToStep(step - 1);
    });

    /* ── Service type selection ── */
    $section.on('click', '.service-option', function () {
      $section.find('.service-option').removeClass('is-selected');
      $(this).addClass('is-selected');
      $section.find('#syb-service-type').val($(this).data('value'));
      $section.find('.service-options').removeClass('syb-options-invalid');
    });

    /* ── File upload: capture names ── */
    $section.on('change', '#syb-file-input', function () {
      var names = [];
      $.each(this.files, function (i, f) { names.push(f.name); });
      var nameStr = names.join(', ');
      $section.find('#syb-images').val(nameStr);
      var $lbl = $section.find('#syb-file-label');
      $lbl.text(nameStr || '').toggleClass('hidden', !nameStr);
    });

    /* ── Clear invalid on input ── */
    $section.on('input change', '.is-invalid', function () {
      if ($(this).val().trim()) $(this).removeClass('is-invalid');
    });
  }

  $(document).ready(function () {
    $('.sell-your-boat-section').each(function () {
      initSYBForm($(this));
    });
  });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sold-items"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSliders() {
    document.querySelectorAll('.sold-items__slider').forEach(function (sliderEl) {
      if (sliderEl.classList.contains('slick-initialized')) return;
      var wrap = sliderEl.closest('.sold-items');
      var prevBtn = wrap ? wrap.querySelector('[data-sold-prev]') : null;
      var nextBtn = wrap ? wrap.querySelector('[data-sold-next]') : null;
      var dotsWrap = wrap ? wrap.querySelector('[data-sold-dots]') : null;

      window.jQuery(sliderEl).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        appendDots: dotsWrap ? window.jQuery(dotsWrap) : false,
        prevArrow: prevBtn ? window.jQuery(prevBtn) : '<button type="button" class="slick-prev">Previous</button>',
        nextArrow: nextBtn ? window.jQuery(nextBtn) : '<button type="button" class="slick-next">Next</button>',
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 2 } },
          { breakpoint: 640,  settings: { slidesToShow: 1 } }
        ]
      });
    });
  }

  initSliders();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function parseCount(str) {
      return parseInt(str.replace(/[^0-9]/g, ''), 10) || 0;
    }

    function formatCount(n, hasCommas) {
      return hasCommas ? n.toLocaleString('en-AU') : n.toString();
    }

    function animateCounter(el) {
      var raw = el.getAttribute('data-count') || '0';
      var target = parseCount(raw);
      var hasCommas = raw.indexOf(',') !== -1;
      var duration = 1500;
      var start = null;

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = formatCount(Math.round(eased * target), hasCommas);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = formatCount(target, hasCommas);
        }
      }

      requestAnimationFrame(step);
    }

    document.addEventListener('DOMContentLoaded', function() {
      var counters = document.querySelectorAll('.stats-section__number[data-count]');
      if (!counters.length) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.5 });

        counters.forEach(function(el) { observer.observe(el); });
      } else {
        counters.forEach(animateCounter);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  (function($) {
    var $section = $('.tabs-container');
    var $navItems = $section.find('.tabs-nav__item');
    var $panes = $section.find('.tabs-pane');

    function scrollTabIntoView(btn) {
      var nav = btn.closest('.tabs-nav');
      if (!nav) return;
      var targetScroll = btn.offsetLeft - (nav.offsetWidth / 2) + (btn.offsetWidth / 2);
      nav.scrollTo({ left: targetScroll, behavior: 'smooth' });
    }

    $navItems.on('click', function() {
      var $btn = $(this);
      var index = $navItems.index($btn);

      $navItems.removeClass('is-active').attr('aria-selected', 'false');
      $btn.addClass('is-active').attr('aria-selected', 'true');

      $panes.removeClass('is-active');
      $panes.eq(index).addClass('is-active');

      scrollTabIntoView($btn[0]);
    });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function loadScript(src, id, onLoad) {
    var existing = document.getElementById(id);
    if (existing) {
      if (existing.dataset.ready) {
        onLoad();
      } else {
        existing.addEventListener('load', onLoad);
      }
      return;
    }
    var el = document.createElement('script');
    el.id = id;
    el.src = src;
    el.onload = function () {
      el.dataset.ready = '1';
      onLoad();
    };
    document.head.appendChild(el);
  }

  function initSliders() {
    document.querySelectorAll('.testimonials-section__slider').forEach(function (sliderEl) {
      if (sliderEl.classList.contains('slick-initialized')) return;
      var section = sliderEl.closest('.testimonials-section');
      var prevBtn = section ? section.querySelector('[data-testimonials-prev]') : null;
      var nextBtn = section ? section.querySelector('[data-testimonials-next]') : null;
      var dotsWrap = section ? section.querySelector('[data-testimonials-dots]') : null;

      window.jQuery(sliderEl).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        appendDots: dotsWrap ? window.jQuery(dotsWrap) : false,
        arrows: prevBtn !== null,
        prevArrow: prevBtn ? window.jQuery(prevBtn) : false,
        nextArrow: nextBtn ? window.jQuery(nextBtn) : false,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 2 } },
          { breakpoint: 640,  settings: { slidesToShow: 1 } }
        ]
      });
    });
  }

  loadScript(
    'https://code.jquery.com/jquery-3.7.1.min.js',
    'jquery-cdn',
    function () {
      loadScript(
        'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js',
        'slick-cdn',
        function () {
          initSliders();
        }
      );
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-image"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function parseCount(str) {
      return parseInt(str.replace(/[^0-9]/g, ''), 10) || 0;
    }

    function formatCount(n, hasCommas) {
      return hasCommas ? n.toLocaleString('en-AU') : n.toString();
    }

    function animateCounter(el) {
      var raw = el.getAttribute('data-count') || '0';
      var target = parseCount(raw);
      var hasCommas = raw.indexOf(',') !== -1;
      var duration = 1500;
      var start = null;

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = formatCount(Math.round(eased * target), hasCommas);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = formatCount(target, hasCommas);
        }
      }

      requestAnimationFrame(step);
    }

    document.addEventListener('DOMContentLoaded', function() {
      var counters = document.querySelectorAll('.text-image__stat-number[data-count]');
      if (!counters.length) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.5 });

        counters.forEach(function(el) { observer.observe(el); });
      } else {
        counters.forEach(animateCounter);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function parseCount(str) {
      return parseInt(str.replace(/[^0-9]/g, ''), 10) || 0;
    }

    function formatCount(n, hasCommas) {
      return hasCommas ? n.toLocaleString('en-AU') : n.toString();
    }

    function animateCounter(el) {
      var raw = el.getAttribute('data-count') || '0';
      var target = parseCount(raw);
      var hasCommas = raw.indexOf(',') !== -1;
      var duration = 1500;
      var start = null;

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = formatCount(Math.round(eased * target), hasCommas);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = formatCount(target, hasCommas);
        }
      }

      requestAnimationFrame(step);
    }

    document.addEventListener('DOMContentLoaded', function() {
      var counters = document.querySelectorAll('.text-image__stat-number[data-count]');
      if (!counters.length) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.5 });

        counters.forEach(function(el) { observer.observe(el); });
      } else {
        counters.forEach(animateCounter);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
(function ($) {
  function initTimeline($section) {
    var $track  = $section.find('.timeline-track');
    var $items  = $section.find('.timeline-item');
    var $prev   = $section.find('.timeline-prev');
    var $next   = $section.find('.timeline-next');
    var total   = $items.length;
    var current = 0;

    function perView() {
      var w = $(window).width();
      if (w >= 1024) return Math.min(3, total);
      if (w >= 640)  return Math.min(2, total);
      return 1;
    }

    function maxIdx() {
      return Math.max(0, total - perView());
    }

    function update() {
      var pv  = perView();
      var pct = (100 / pv) * current;
      $items.css('width', (100 / pv) + '%');
      $track.css('transform', 'translateX(-' + pct + '%)');
      $prev.prop('disabled', current <= 0);
      $next.prop('disabled', current >= maxIdx());
    }

    $prev.on('click', function () {
      if (current > 0) { current--; update(); }
    });

    $next.on('click', function () {
      if (current < maxIdx()) { current++; update(); }
    });

    var resizeTimer;
    $(window).on('resize.timeline-' + $section.index(), function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        current = Math.min(current, maxIdx());
        update();
      }, 100);
    });

    update();
  }

  $(document).ready(function () {
    $('.timeline-section').each(function () {
      initTimeline($(this));
    });
  });
})(jQuery);

  } catch(e) { console.error(e); }
})();
})();
